import React from 'react';
import axios from 'axios';
import Icon from '../../../../../../../../components/icon/index';
import Button from '../../../../../../../../components/button/index';
import {API_ROOT} from '../../../../../../../../utils/index';
import './index.css';

class UpdateDirectory extends React.Component {

	constructor(props){
		super(props);

		this.update = this.update.bind(this);
	}

	update(){
		axios.post(API_ROOT + '/api/directory/update', {}, {withCredentials: true});

		if(document.querySelector('.update-directory')){
			document.querySelector('.update-directory').children[0].classList.add('spin');
			setTimeout(() => {
				document.querySelector('.update-directory').children[0].classList.remove('spin');
			},1000)
		}

	}

	render() {
		return (
			<Button onClick={this.update} className="h-100 update-directory" type="button">
				<Icon className="m-0" name="refresh"/>
			</Button>
		)
	}
}

export default UpdateDirectory;